export enum ChildParties {
    'PARENT_CUST_CODE' = 'CHILD_PARTIES-PARENT_CUST_CODE',
    'PARENT_CUST_NAME' = 'CUSTOMRS-PARENT_CUST_NAME',
    'CHILD_CUST_CODE' = 'CHILD_PARTIES-CHILD_CUST_CODE',
    'CHILD_CUST_NAME' = 'CUSTOMRS-CHILD_CUST_NAME',
    'CHILD_IDENTIFIER_TYPE' = 'CHILD_PARTIES-CHILD_IDENTIFIER_TYPE',
    'CHILD_ID' = 'CHILD_PARTIES-CHILD_ID',
    'CHILD_BK_TYPE' = 'CHILD_PARTIES-CHILD_BK_TYPE',
    'CHILD_BK_ID' = 'CHILD_PARTIES-CHILD_BK_ID'
};
